"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
/* tslint:disable */
require("isomorphic-fetch");
var ApiError = /** @class */ (function () {
    function ApiError(message) {
        this.details = null;
        this.message = message;
    }
    return ApiError;
}());
/**
 * RESTful API specification.

 * @class Api
 * @param {(string)} [domainOrOptions] - The project domain.
 */
var Api = /** @class */ (function () {
    function Api() {
        this.baseUrl = 'https://localhost';
        this.token = '';
    }
    Api.prototype.serializeQueryParams = function (parameters) {
        return Object.keys(parameters)
            .reduce(function (acc, p) {
            var param = parameters[p];
            if (typeof param === 'undefined' || param === '') {
                return acc;
            }
            return tslib_1.__spreadArrays(acc, [
                encodeURIComponent(p) + "=" + encodeURIComponent(String(parameters[p])),
            ]);
        }, [])
            .join('&');
    };
    Api.prototype.transformParameter = function (value, transformOperation) {
        switch (transformOperation) {
            case 'joinUsingPipes':
                return Array.isArray(value) ? value.join('|') : value;
            default:
                return value;
        }
    };
    Api.prototype.setBaseUrl = function (baseUrl) {
        this.baseUrl = baseUrl;
    };
    Api.prototype.setToken = function (token) {
        this.token = token;
    };
    Api.prototype.appendAuthHeaders = function (headerParams) {
        var headers = new Headers(headerParams);
        if (this.token) {
            headers.append('Authorization', "Bearer " + this.token);
        }
        return headers;
    };
    Api.prototype.request = function (method, url, body, headers, queryParameters) {
        if (headers === void 0) { headers = new Headers(); }
        if (queryParameters === void 0) { queryParameters = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var queryParams, urlWithParams, form, k, response, err, _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        queryParams = queryParameters && Object.keys(queryParameters).length
                            ? this.serializeQueryParams(queryParameters)
                            : null;
                        urlWithParams = url + (queryParams ? '?' + queryParams : '');
                        if (headers.get('Content-Type') === 'multipart/form-data') {
                            form = new FormData();
                            for (k in body) {
                                form.append(k, body[k]);
                            }
                            body = form;
                        }
                        else if (headers.get('Content-Type') === 'application/json' &&
                            body &&
                            Object.keys(body).length > 0) {
                            body = JSON.stringify(body);
                        }
                        else {
                            body = undefined;
                        }
                        if (headers.get('Content-Type') === 'multipart/form-data') {
                            headers["delete"]('Content-Type');
                        }
                        return [4 /*yield*/, fetch(urlWithParams, { method: method, headers: headers, body: body })];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) return [3 /*break*/, 2];
                        return [2 /*return*/, response.json()];
                    case 2:
                        err = new ApiError(response.statusText);
                        _a = err;
                        return [4 /*yield*/, response.json()];
                    case 3:
                        _a.details = _b.sent();
                        throw err;
                }
            });
        });
    };
    /**
     * Endpoint pre stiahnutie súboru a ulozenie do cieľového adresára zadefinovaného ako parameter destination (nepovinné)
     * @method
     * @name Api#createFileFromUrl
     */
    Api.prototype.createFileFromUrl = function (appId, appSpace, parameters, body) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/app/{app_id}/space/{app_space}/filefromurl';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{app_id}', appId.toString());
        path = path.replace('{app_space}', appSpace.toString());
        return this.request('POST', "" + this.baseUrl + path, body, headers, queryParameters);
    };
    /**
     * Endpoint pre získanie zoznamu súborov pre všetky adresáre
     * @method
     * @name Api#getFiles
     */
    Api.prototype.getFiles = function (appId, appSpace, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/app/{app_id}/space/{app_space}/files';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        if (typeof parameters['parentId'] !== 'undefined') {
            queryParameters['parent_id'] = parameters['parentId'];
        }
        queryParameters['parent_id'] = this.transformParameter(queryParameters['parent_id']);
        if (typeof parameters['name'] !== 'undefined') {
            queryParameters['name'] = parameters['name'];
        }
        queryParameters['name'] = this.transformParameter(queryParameters['name']);
        if (typeof parameters['type'] !== 'undefined') {
            queryParameters['type'] = parameters['type'];
        }
        queryParameters['type'] = this.transformParameter(queryParameters['type']);
        if (typeof parameters['smarttag'] !== 'undefined') {
            queryParameters['smarttag'] = parameters['smarttag'];
        }
        queryParameters['smarttag'] = this.transformParameter(queryParameters['smarttag'], 'joinUsingPipes');
        if (typeof parameters['query'] !== 'undefined') {
            queryParameters['query'] = parameters['query'];
        }
        queryParameters['query'] = this.transformParameter(queryParameters['query']);
        queryParameters['sorter'] = '-created_date';
        if (typeof parameters['sorter'] !== 'undefined') {
            queryParameters['sorter'] = parameters['sorter'];
        }
        queryParameters['sorter'] = this.transformParameter(queryParameters['sorter']);
        queryParameters['offset'] = 0;
        if (typeof parameters['offset'] !== 'undefined') {
            queryParameters['offset'] = parameters['offset'];
        }
        queryParameters['offset'] = this.transformParameter(queryParameters['offset']);
        queryParameters['limit'] = 50;
        if (typeof parameters['limit'] !== 'undefined') {
            queryParameters['limit'] = parameters['limit'];
        }
        queryParameters['limit'] = this.transformParameter(queryParameters['limit']);
        path = path.replace('{app_id}', appId.toString());
        path = path.replace('{app_space}', appSpace.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     * Endpoint pre upload súboru do cieľového adresára zadefinovaného ako parameter destination (nepovinné)
     * @method
     * @name Api#uploadFile
     */
    Api.prototype.uploadFile = function (appId, appSpace, parameters, form) {
        var path = '/app/{app_id}/space/{app_space}/files';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'multipart/form-data');
        path = path.replace('{app_id}', appId.toString());
        path = path.replace('{app_space}', appSpace.toString());
        return this.request('POST', "" + this.baseUrl + path, form, headers, queryParameters);
    };
    /**
     * Endpoint pre úpravu informácií o viacerých súboroch podľa ID súborov
     * @method
     * @name Api#editFilesByIds
     */
    Api.prototype.editFilesByIds = function (appId, appSpace, parameters, body) {
        var path = '/app/{app_id}/space/{app_space}/files';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{app_id}', appId.toString());
        path = path.replace('{app_space}', appSpace.toString());
        return this.request('PUT', "" + this.baseUrl + path, body, headers, queryParameters);
    };
    /**
     * Endpoint pre zmazanie viacerých súborov podľa ID
     * @method
     * @name Api#deleteFilesByIds
     */
    Api.prototype.deleteFilesByIds = function (appId, appSpace, parameters, body) {
        var path = '/app/{app_id}/space/{app_space}/files';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{app_id}', appId.toString());
        path = path.replace('{app_space}', appSpace.toString());
        return this.request('DELETE', "" + this.baseUrl + path, body, headers, queryParameters);
    };
    /**
     * Endpoint pre hromadný presun súborov do jedného priečinku
     * @method
     * @name Api#moveFiles
     */
    Api.prototype.moveFiles = function (appId, appSpace, parameters, body) {
        var path = '/app/{app_id}/space/{app_space}/files/move';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{app_id}', appId.toString());
        path = path.replace('{app_space}', appSpace.toString());
        return this.request('PUT', "" + this.baseUrl + path, body, headers, queryParameters);
    };
    /**
     * Endpoint pre detail súboru na základe jeho ID
     * @method
     * @name Api#getFileById
     */
    Api.prototype.getFileById = function (appId, appSpace, fileId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/app/{app_id}/space/{app_space}/file/{file_id}';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{app_id}', appId.toString());
        path = path.replace('{app_space}', appSpace.toString());
        path = path.replace('{file_id}', fileId.toString());
        return this.request('GET', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     * Endpoint pre úpravu informácií o súbore podľa ID súboru
     * @method
     * @name Api#editFileById
     */
    Api.prototype.editFileById = function (appId, appSpace, fileId, parameters, body) {
        var path = '/app/{app_id}/space/{app_space}/file/{file_id}';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{app_id}', appId.toString());
        path = path.replace('{app_space}', appSpace.toString());
        path = path.replace('{file_id}', fileId.toString());
        return this.request('PUT', "" + this.baseUrl + path, body, headers, queryParameters);
    };
    /**
     * Endpoint pre zmazanie súboru podľa ID
     * @method
     * @name Api#deleteFileById
     */
    Api.prototype.deleteFileById = function (appId, appSpace, fileId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/app/{app_id}/space/{app_space}/file/{file_id}';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{app_id}', appId.toString());
        path = path.replace('{app_space}', appSpace.toString());
        path = path.replace('{file_id}', fileId.toString());
        return this.request('DELETE', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    /**
     * Endpoint pre presun súboru do priečinku
     * @method
     * @name Api#moveFile
     */
    Api.prototype.moveFile = function (appId, appSpace, fileId, destinationId, parameters) {
        if (parameters === void 0) { parameters = {}; }
        var path = '/app/{app_id}/space/{app_space}/file/{file_id}/move/{destination_id}';
        var headers = new Headers();
        var queryParameters = {};
        headers = this.appendAuthHeaders(headers);
        headers.append('Accept', 'application/json');
        headers.append('Content-Type', 'application/json');
        path = path.replace('{app_id}', appId.toString());
        path = path.replace('{app_space}', appSpace.toString());
        path = path.replace('{file_id}', fileId.toString());
        path = path.replace('{destination_id}', destinationId.toString());
        return this.request('PUT', "" + this.baseUrl + path, {}, headers, queryParameters);
    };
    return Api;
}());
exports["default"] = new Api();
